const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/color-cards-item', {
  title: 'Card colorido',
  description:
    'Card com opção de escolher cor e conteúdo (imagem ou texto) e descrição',
  icon: 'embed-photo',
  category: 'design',
  parent: ['app/color-cards'],
  attributes,
  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
